import { useApplicationModals } from "app/common/hooks";
import {
  useCollector,
  usePaginatedCollector,
} from "app/integration/common/hooks";
import {
  BadgeButton,
  IconButton,
  ServerSidePaginationButtons,
} from "app/components/atoms/button";
import { SearchInput } from "app/components/atoms/input";
import Table from "app/components/atoms/table";
import Typography from "app/components/atoms/typography";
import MainLayout from "app/layouts/main";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

function StockMovement() {
  let { id } = useParams();
  const [productVariants] = useCollector({
    modelName: "productVariant",
    params: { id: id },
  });

  const breadcrumbItems = [
    { label: "Product", href: "/product" },
    {
      label: "Product Variant",
      href: `/product/detail/${productVariants[0]?.product_id}`,
    },
    { label: "Stock Movement", href: "#" }
  ];
  const { openModal, setPayloads } = useApplicationModals();
  const [params, setParams] = useState({
    search: "",
    product_variant_id: id,
    page: 1,
    limit: 10,
  });

  useEffect(() => {
    collect(params);
  }, [params]);

  const [
    stockMovements,
    setStockMovements,
    stockMovementsLoader,
    collect,
    stockMovementPaginationProps,
  ] = usePaginatedCollector({ modelName: "stockMovement", params: params });

  return (
    <MainLayout
      activeSidebarNavigation="warehouse"
      activeSidebarChild="stock_opname"
      breadcrumbItems={breadcrumbItems}
      pageTitle="Stock Movement"
    >
      <Table.Container>
        {/* <Table.UtilitiesWrapper>
          <Table.SearchBarWrapper>
            <Table.SearchBarItemWrapper>
              <SearchInput testId="stock-movement-search-input"
                placeholder="Cari Stock Movement"
                type="text"
                value={params.stock_opname_search}
                // onChange={handleQueryChange}
                onChange={(e) =>
                  setParams({ ...params, stock_opname_search: e.target.value })
                }
              />
            </Table.SearchBarItemWrapper>
          </Table.SearchBarWrapper>
        </Table.UtilitiesWrapper> */}
        <Table.Wrapper asIndex={false}>
          <Table.Header>
            <Table.HeaderRow>
              <Table.Heading>Kode</Table.Heading>
              <Table.Heading>Produk</Table.Heading>
              <Table.Heading>Produk Variant</Table.Heading>
              <Table.Heading>Tipe Transaksi</Table.Heading>
              <Table.Heading>Stok Awal</Table.Heading>
              <Table.Heading>Stok Akhir</Table.Heading>
              <Table.Heading>Jumlah Masuk</Table.Heading>
              <Table.Heading>Jumlah Keluar</Table.Heading>
              <Table.Heading>Tanggal</Table.Heading>
            </Table.HeaderRow>
          </Table.Header>
          <Table.Body>
            {stockMovements?.map((stockMovement, key) => (
              <Table.BodyRow key={key}>
                <Table.Cell>
                    {stockMovement?.code}
                </Table.Cell>
                <Table.Cell>{productVariants[0]?.product_detail?.name}</Table.Cell>
                <Table.Cell>{productVariants[0]?.color?.name}, {productVariants[0]?.size?.name}</Table.Cell>
                <Table.Cell>{stockMovement?.transactionable_type}</Table.Cell>
                <Table.Cell>
                  {parseInt(stockMovement?.opening_balance)}
                </Table.Cell>
                <Table.Cell>
                  {parseInt(stockMovement?.closing_balance)}
                </Table.Cell>
                <Table.Cell>
                  {parseInt(stockMovement?.qty_in)}
                </Table.Cell>
                <Table.Cell>
                  {parseInt(stockMovement?.qty_out)}
                </Table.Cell>
                <Table.Cell>
                  <Typography.Date date={stockMovement?.createdAt} format="dd MMMM yyyy hh:mm:ss" />
                </Table.Cell>
              </Table.BodyRow>
            ))}
          </Table.Body>
        </Table.Wrapper>
        <Table.PaginationWrapper>
          <ServerSidePaginationButtons
            paginationProps={stockMovementPaginationProps}
            params={params}
            setParams={setParams}
          />
        </Table.PaginationWrapper>
      </Table.Container>
    </MainLayout>
  );
}

export default StockMovement;
